import quizService from './quiz.Service';

export default quizService;
